module.exports = __webpack_public_path__ + "img/SWP_Sword_1H_04.077d7d0b.png";